import('./assets/js/tabbar.ts').then((Tabbar) => {
    Tabbar = Tabbar.default;
    window.TCMS.tabBar = new Tabbar();
});
